var map = {
	"./address_icon.png": "jVew",
	"./address_img.png": "282b",
	"./ali_icon.png": "anS0",
	"./bg.jpg": "ogGJ",
	"./clock_icon.png": "Co7d",
	"./coupon_bg.png": "Oa5l",
	"./favicon.png": "y/t1",
	"./has_evaluated.png": "ywvI",
	"./input_icon.png": "DP+m",
	"./logo_img.png": "erur",
	"./no_data.png": "OjLq",
	"./no_list.png": "7IpT",
	"./not_evaluated.png": "K4md",
	"./payment_eq_wx.png": "xpwc",
	"./payment_eq_zfb.png": "+j2F",
	"./payment_top.png": "zXNh",
	"./pinglun_icon.png": "OTx5",
	"./preson_bg.png": "MzxU",
	"./select_bottom.png": "2jIq",
	"./select_icon.png": "XTBj",
	"./select_top.png": "c4Py",
	"./shopcar_no.png": "n0Bq",
	"./state_bg.png": "lJDu",
	"./transaction_close.png": "vNEX",
	"./waiting_delivery.png": "Gp+l",
	"./waiting_pay.png": "DsQj",
	"./waiting_receipt.png": "I9bI",
	"./wx_icon.png": "iCe8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OFlD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index ^\.\/.*$
// module id = OFlD
// module chunks = 0